// Nome do comprador / vendedor de um negócio, sem partilhar o contacto do colega.
// Regra da Sónia (out/2026): os contactos dos clientes dos colegas não são partilhados;
// só se veem os dados preenchidos no CPCV desse negócio, e só depois de o CPCV estar completo.

const nomeDe = (p) => (p && (p.nome_completo || p.nome || p.nome_empresa || p.nome_heranca)) || "";
const ESTADOS_CPCV_COMPLETO = ["completo", "pdf_gerado", "enviado"];

export const cpcvCompleto = (c) => !!c && !c.deleted_at && (ESTADOS_CPCV_COMPLETO.includes(c.estado) || (!!c.parte_ang_completa && !!c.parte_venda_completa));

// papel: "comprador" | "vendedor"
// lead: o contacto, se este utilizador o pode ver; idLead: o id guardado no negócio/proposta (pode ser de um colega)
// externo: nome escrito à mão para um cliente de fora (colega de outra agência); cpcv: o CPCV do negócio, se existir
// colega: nome do consultor do outro lado
export function nomeParte({ papel, lead, idLead, externo, cpcv, colega }) {
  if (lead) return nomeDe(lead) || "—";
  if (cpcvCompleto(cpcv)) {
    const lista = (papel === "comprador" ? cpcv.proponentes : cpcv.vendedores_promitentes) || [];
    const nomes = lista.map(nomeDe).filter(n => n && n !== "Cliente Externo");
    if (nomes.length) return nomes.join(", ");
  }
  if (externo) return externo;
  if (idLead) return `${papel === "comprador" ? "Comprador" : "Vendedor"} do colega${colega ? " · " + colega : ""}`;
  return "—";
}

// O CPCV de um negócio/proposta numa lista já carregada (o mais recente)
export const cpcvDe = (lista, { negocioId, propostaId }) => (lista || [])
  .filter(c => !c.deleted_at && ((negocioId && c.negocio_id === negocioId) || (propostaId && c.proposta_id === propostaId)))
  .sort((a, b) => String(b.created_at || "").localeCompare(String(a.created_at || "")))[0] || null;
